import React from "react";
import { FaSync } from "react-icons/fa";
import styles from "./SafetyFormActions.module.css";

// Back to Table Button
// backToText is to indicate if we want the "Back to" in our button label
export const BackToTableButton = ({
  backToTableFunction,
  tableName,
  backToText = true,
}) => {
  return (
    <button className={styles.bottomRowButton} onClick={backToTableFunction}>
      Back to Table
    </button>
  );
};

// Save Draft Safety Form Button
export const SaveDraftButton = ({ saveDraftFunction }) => {
  return (
    <button className={styles.bottomRowButton} onClick={saveDraftFunction}>
      Save
    </button>
  );
};

// Submit Safety Form  Button
export const SubmitSafetyFormButton = ({ submitFunction }) => {
  return (
    <button className={styles.bottomRowButton} onClick={submitFunction}>
      Submit
    </button>
  );
};

// New Safety From button Button
export const NewSafetyFormButton = ({ formName, newFormFunction }) => {
  return (
    <button className={styles.safetyFormButton} onClick={newFormFunction}>
      New {formName}
    </button>
  );
};

// Edit Safety Form Button
export const EditSafetyFormButton = ({
  formName,
  editFunction,
  disabled = false,
}) => {
  return (
    <button
      className={styles.safetyFormButton}
      onClick={() => {
        if (!disabled) editFunction();
      }}
      disabled={disabled}
      title={disabled ? "Edit not available" : undefined}
    >
      Edit {formName}
    </button>
  );
};

// View Safety Form Button - for viewing submitted forms (read-only)
export const ViewSafetyFormButton = ({
  formName,
  viewFunction,
  disabled = false,
}) => {
  return (
    <button
      className={styles.safetyFormButton}
      onClick={() => {
        if (!disabled) viewFunction();
      }}
      disabled={disabled}
      title={disabled ? "Select a form to view" : undefined}
    >
      Open {formName}
    </button>
  );
};

// SafetyForm Lists Refresh Button - for refreshing data in each tab
export const RefreshSafetyFormListsButton = ({
  refreshFunction,
  isLoading = false,
}) => {
  return (
    <button
      className={`${styles.refreshButton} ${isLoading ? styles.loading : ""}`}
      onClick={refreshFunction}
      disabled={isLoading}
      title="Refresh Safety Form lists from server"
    >
      <FaSync className={isLoading ? styles.spinning : ""} />
      {"Refresh"}
    </button>
  );
};

// Download Safety Form PDF Button - for downloading selected forms as PDFs
export const DownloadSafetyFormPdfButton = ({
  formName,
  onClick,
  disabled = false,
}) => {
  return (
    <button
      className={styles.safetyFormButton}
      onClick={onClick}
      disabled={disabled}
      title={`Download checked ${formName} forms as PDFs`}
    >
      {formName} PDFs
    </button>
  );
};
